import { createAction } from "./store";

// Setters.
export const SET_ADDING_TO_LIST = "SET_ADDING_TO_LIST";
export const setAddingToList = payload =>
  createAction(SET_ADDING_TO_LIST, payload);

export const SET_BOX_CONTENT = "SET_BOX_CONTENT";
export const setBoxContent = payload => createAction(SET_BOX_CONTENT, payload);

export const SET_CREATING_LIST = "SET_CREATING_LIST";
export const setCreatingList = payload =>
  createAction(SET_CREATING_LIST, payload);

export const SET_INPUT_ERROR = "SET_INPUT_ERROR";
export const setInputError = payload => createAction(SET_INPUT_ERROR, payload);

export const SET_INPUT_VISIBILITY = "SET_INPUT_VISIBILITY";
export const setInputVisibility = payload =>
  createAction(SET_INPUT_VISIBILITY, payload);

export const SET_LISTS = "SET_LISTS";
export const setLists = data => createAction(SET_LISTS, data);

export const SET_REMOVING_FROM_LIST = "SET_REMOVING_FROM_LIST";
export const setRemovingFromList = payload =>
  createAction(SET_REMOVING_FROM_LIST, payload);

export const SET_USER_ID = "SET_USER_ID";
export const setUserId = userId => createAction(SET_USER_ID, userId);

// Verbs.
export const ADD_LIST = "ADD_LIST";
export const addList = list => createAction(ADD_LIST, list);

export const ADD_TO_LIST = "ADD_TO_LIST";
export const addToList = payload => createAction(ADD_TO_LIST, payload);

export const CLICK_CREATE = "CLICK_CREATE";
export const clickCreate = () => createAction(CLICK_CREATE);

export const CLOSE_BOX = "CLOSE_BOX";
export const closeBox = artId => createAction(CLOSE_BOX, artId);

export const CLOSE_BOXES = "CLOSE_BOXES";
export const closeBoxes = () => createAction(CLOSE_BOXES);

export const CLOSE_OTHER_BOXES = "CLOSE_OTHER_BOXES ";
export const closeOtherBoxes = artId => createAction(CLOSE_OTHER_BOXES, artId);

export const CREATE_LIST = "CREATE_LIST";
export const createList = listName => createAction(CREATE_LIST, listName);

export const ICON_CLICK = "ICON_CLICK";
export const iconClick = payload => createAction(ICON_CLICK, payload);

export const OPEN_BOX = "OPEN_BOX";
export const openBox = artId => createAction(OPEN_BOX, artId);

export const REMOVE_FROM_LIST = "REMOVE_FROM_LIST";
export const removeFromList = payload =>
  createAction(REMOVE_FROM_LIST, payload);

// Initiators.
export const INIT = "INIT";
export const init = artId => createAction(INIT, artId);

export const INIT_ARTWORK = "INIT_ARTWORK";
export const initArtwork = () => createAction(INIT_ARTWORK);
